<template>
  <div class="technology_services">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <div class="part1">
      <p class="title">核心技术</p>
      <ul>
        <li v-for="item in part1">
          <img :src="item.imgUrl" />
          <p class="name">{{item.name}}</p>
        </li>
      </ul>
      <div class="clear"></div>
    </div>

    <div class="part2">
      <p class="title">数据应用模式</p>
      <p class="remark">基于数据分析的精准用户推广服务方案</p>

      <div class="model">
        <img class="img1" :src="part2.imgUrl1" @click="noClick">
        <img class="img2" :src="part2.imgUrl2" @click="noClick">
        <img class="img3" :src="part2.imgUrl3" @click="noClick">
        <img class="img4" :src="part2.imgUrl4" @click="noClick">
        <img class="img5" :src="part2.imgUrl5" @click="noClick">
      </div>

      <!-- <p class="remark">截止到目前道泰已拥有</p>
      <ul>
        <li>
          <p class="msg1">9<span>亿人</span></p>
          <p class="msg2">可分析且目标化用户</p>
        </li>
        <li>
          <p class="msg1">2400<span>个</span></p>
          <p class="msg2">现有标签库</p>
        </li>
        <li>
          <p class="msg1">2000<span>万/天</span></p>
          <p class="msg2">保险用户</p>
        </li>
        <li>
          <p class="msg1">4000<span>万/天</span></p>
          <p class="msg2">金融用户</p>
        </li>
      </ul>
      <div class="clear"></div>

      <p class="text">根据以上标签，到大数据中心定向匹配用户，进行精准推送，再根据转化效果，取种子用户，</p>
      <p class="text">进行放大/约束，再次定向用户或者优化标签。</p> -->
    </div>

    <div class="part3">
      <p class="title">道泰大数据业务流程</p>
      <img class="img1" :src="part3.imgUrl1"  @click="noClick"/>
      <!-- <p class="text">我们已经具有海量数据的分析能力，</p>
      <p class="text">并在信用卡用户的精准分析上积累了丰富的经验</p>
      <p class="text">同样各家金融机构将面临数据资产化的要求，</p>
      <p class="text">我们具备在大数据应用层面的合作能力</p>
      <div class="model">
        <img class="img2" :src="part3.imgUrl2"  @click="noClick"/>
        <img class="img3" :src="part3.imgUrl3"  @click="noClick"/>
      </div> -->
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/mComponents/Header"
  import Banners from "@/mComponents/Banners"
  import Footer from "@/mComponents/Footer"

  export default {
    name: 'mTechnology_Services',
    data() {
      return {
        banner: require("@/assets/imgs/mobile/banner-02.png"),
        part1: [
          {imgUrl:require("@/assets/imgs/mobile/ic-tec-logo-spark.png"),name:"基于spark大数据组件实现对海量数据快速的规整处理能力，能够快速的对几十G数据进行规整处理。"},
          {imgUrl:require("@/assets/imgs/mobile/ic-tec-logo-avro.png"),name:"基于Avro格式的数据存储技术对数据进行有效存储，灵活存储，向上兼容，扩展方便，读取快速。"},
          {imgUrl:require("@/assets/imgs/mobile/ic-tec-logo-tgi.png"),name:"基于TGI(Target Group Index)的数据分析方法，对用户画像数据进行灵活分析处理。挑选出最优质的受众特征。"},
          {imgUrl:require("@/assets/imgs/mobile/ic-tec-logo-elastic.png"),name:"采用elasticsearch构建营销中心的用户库，并提供友好的操作界面供运营人员操作，方便维护用户库。"},
        ],
        part2: {
          imgUrl1: require("@/assets/imgs/mobile/img-tec-model-00.png"),
          imgUrl2: require("@/assets/imgs/mobile/img-tec-model-01.png"),
          imgUrl3: require("@/assets/imgs/mobile/img-tec-model-04.png"),
          imgUrl4: require("@/assets/imgs/mobile/img-tec-model-02.png"),
          imgUrl5: require("@/assets/imgs/mobile/img-tec-model-03.png"),
        },
        part3: {
          imgUrl1: require("@/assets/imgs/mobile/img-tec-02.png"),
          imgUrl2: require("@/assets/imgs/mobile/img-tec-03-line.png"),
          imgUrl3: require("@/assets/imgs/mobile/img-tec-03-circle.png"),
        }
      }
    },
    components: {
      Header,Banners,Footer,
    },
    created() {
      window.scrollTo(0,0);
      this.$store.commit('changeNavsM', 'mTechnology_Services')
    },
    methods: {
      noClick() {
        return false;
      }
    },
    mounted() {
      $('.part1 ul').addClass('active')
      var screenHeight =  document.documentElement.clientHeight
      setTimeout(function() {
        window.onscroll = function() {
          var bool = $(window).scrollTop()+$(window).height()==$(document).height();
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let fontSize = getComputedStyle(window.document.documentElement)['font-size'];
          if(scrollTop>30) {
            $(".icon-m-up").css("display","block")
            $(".top").addClass("active")
          } else {
            $(".icon-m-up").css("display","none")
            $(".top").removeClass("active")
          }
          var lis = $('.part2 .model img:not(".img1") ')
          for(var i =0;i<lis.length;i++) {
            var offsetTop = $(lis[i]).offset().top
            if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
              $(lis[i]).addClass('active')
            }
          }
        }
      },100)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';
  .technology_services {
    background-color: #fff;

    .clear {
      clear: both;
    }

    .part1 {
      padding-bottom: 0.6rem;
      padding-top: 0.6rem;
      .title {
        font-size:0.48rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-bottom: 0.2rem;
      }
      ul {
        margin: 0 0.6rem;
        display: inline-block;
        li {
          width: 2.49rem;
          background:rgba(238,238,238,1);
          border:1px solid rgba(204,204,204,1);
          box-shadow:0px 10px 10px 0px rgba(170,170,170,0.2);
          border-radius:8px;
          float: left;
          margin: 0.4rem 0.3rem 0;
          img {
            display: block;
            width: 2.5rem;
            background-color: #fff;
            border-radius:8px 8px 0 0;
            padding: 0.1rem 0.08rem;
            box-sizing: border-box;
          }
          .name {
            font-size:0.2rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            line-height:0.32rem;
            margin: 0.11rem 0.14rem 0.19rem;
            height: 1.8rem;
            letter-spacing: 0.3px;
          }
        }
      }
    }

    .part2 {
      background:rgba(237,237,237,1);
      padding: 0.7rem 0 0.45rem;
      p {
        text-align: center;
      }
      .title {
        font-size:0.48rem;
        line-height: 0.7rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
      .remark {
        font-size:0.3rem;
        line-height: 0.6rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
      .text {
        font-size:0.24rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:0.48rem;
        opacity:0.6;
        margin: 0 0.8rem;
      }
      .model{
        position: relative;
        height: 3.5rem;
        width: 100%;
        margin: 0.6rem 0;
        img.active {
          -moz-animation: RotateY 0.7s linear forwards;
          -ms-animation: RotateY 0.7s linear forwards;
          -webkit-animation: RotateY 0.7s linear forwards;
          -o-animation: RotateY 0.7s linear forwards;
          animation: RotateY 0.7s linear forwards;
         }
        img {
          display: block;
          position: absolute;
        }
        .img1 {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 3.4rem;
        }
        .img2,.img3,.img4,.img5 {
          transform:RotateY(90deg);
          -ms-transform:RotateY(90deg); 	/* IE 9 */
          -moz-transform:RotateY(90deg); 	/* Firefox */
          -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
          -o-transform:RotateY(90deg); 	/* Opera */
          width: 1.6rem;
        }
        .img2 {
          top: 19%;
          left: 7%;
        }
        .img3 {
          top: 60%;
          left: 6%;
        }
        .img4 {
          top: 19%;
          left: 72%;
        }
        .img5 {
          top: 60%;
          left: 72%;
        }
      }

      ul {
        margin: 0.3rem 0.5rem;
        display: inline-block;
        li {
          float: left;
          width: 3.2rem;
          .msg1 {
            font-size:0.6rem;
            height: 1.3rem;
            line-height: 1.3rem;
            font-family:PingFangSC-Bold;
            font-weight:bold;
            color:rgba(65,150,255,1);
            span {
              font-size:0.24rem;
              font-family:PingFangSC-Heavy;
              font-weight:800;
              color:rgba(65,150,255,1);
              margin-left: 0.06rem;
            }
          }
          .msg2 {
            font-size:0.24rem;
            line-height: 0.4rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
          }
        }
      }
    }

    .part3 {
      padding: 0.7rem 0;
      p {
        text-align: center;
      }
      .title {
        font-size:0.48rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height: 0.7rem;
      }
      .text {
        font-size:0.2rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:0.5rem;
      }
      img {
        display: block;
      }
      .img1 {
        width: 5.4rem;
        height: 5.4rem;
        margin: 0.4rem auto;
      }
      .model {
        width: 6.2rem;
        height: 2.7rem;
        position: relative;
        margin: 0.2rem auto;
        .img2 {
          width: 6.2rem;
          position: absolute;
          top: 50%;
          left:50%;
          transform: translate(-50%,-50%);
        }
        .img3 {
          width: 6rem;
          position: absolute;
          top: 50%;
          left:50%;
          transform: translate(-50%,-50%);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Mobile/Technology_Services.vue